// Libs
import * as Axios from "axios";
import { merge as _merge } from "lodash";

// App
import { GetDefaultConfig } from "./GetDefaultConfig";

export const MergeDefaultConfig: (...configs: (Axios.AxiosRequestConfig | undefined)[]) => Axios.AxiosRequestConfig = (...configs) => _merge(GetDefaultConfig(), ...configs);
